import { Link, Stack } from "expo-router";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";

import { AppText } from "@/components/AppText";

export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen options={{ title: "Oops!" }} />
      <View style={styles.container}>
        <AppText type="title">This screen does not exist.</AppText>
        <Link href="/(tabs)/feeds" style={styles.link}>
          <AppText type="link">Go to home screen!</AppText>
        </Link>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
});
